<app-dynamic-search-page [p-service]="homeService" [p-name]="'Clientes Totvs'">
</app-dynamic-search-page>